import 'react-dates/initialize';

import { ErrorText } from 'Components/molecules';
import React from 'react';
import classNames from 'classnames/bind';
import moment from 'moment';
import styles from './TimePicker.module.scss';

const cx = classNames.bind(styles);
moment.locale('ko', {
  weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
});

function TimePicker(props) {
  const [part, setPart] = React.useState(
    props.use12Hours ? moment(props.timeValue).format('a') ?? null : '오전',
  );
  const [hour, setHour] = React.useState(
    props.checkedValue
      ? Math.floor(props.checkedValue / 60)
      : props.timeValue
      ? parseInt(moment(props.timeValue).format('h'))
      : null,
  );
  const [minute, setMinute] = React.useState(
    props.checkedValue
      ? Math.floor(props.checkedValue % 60)
      : props.timeValue
      ? parseInt(moment(props.timeValue).format('m'))
      : null,
  );
  const [inputOpen, setInputOpen] = React.useState(!props.inputexist);
  const modalRef = React.useRef();
  const inputRef = React.useRef();
  let dateTime = moment(`${part} ${hour === null ? 0 : hour}:${minute}`, 'a HH:mm').format(
    props.timeFormat,
  );

  React.useEffect(() => {
    if (props.inputexist) {
      if (part !== 'Invalid date')
        props.ChangeHandler(moment(`${part} ${hour === null ? 0 : hour}:${minute}`, 'a HH:mm'));
    } else {
      if (part !== 'Invalid date' && hour !== null)
        props.ChangeHandler(moment(part + ' ' + hour + ':' + minute, 'a HH:mm'));
    }
  }, [part, hour, minute]);

  const handleClickOutside = ({ target }) => {
    if (!inputRef?.current?.contains(target) && !modalRef?.current?.contains(target))
      setInputOpen(false);
  };

  React.useEffect(() => {
    props.inputexist && window.addEventListener('click', handleClickOutside);
    return () => {
      props.inputexist && window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className={cx('time-picker-container', props.borderLeft ? 'border-left' : '')}>
        {props.inputexist && (
          <>
            <input
              className={cx('time-input', inputOpen ? 'open' : 'close', props.errorText && 'error')}
              value={dateTime === 'Invalid date' ? '약 OO시간 OO분' : dateTime}
              onClick={() => setInputOpen(!inputOpen)}
              readOnly
              ref={inputRef}
            />
            {props.errorText && <ErrorText>필수 입력항목입니다.</ErrorText>}
          </>
        )}
        <div
          ref={modalRef}
          className={cx(
            'time-picker-container',
            props.inputexist ? 'time-picker-container-input' : '',
            inputOpen ? 'time-picker-container-open' : '',
            props.mobileSetTime && 'mobile-ul-height',
          )}
        >
          {props.use12Hours && !props.mobileSetTime && <div></div>}
          {!props.use12Hours && (
            <div className={cx('hour-minuite-text')}>
              <div>시간</div>
              <div>분</div>
            </div>
          )}
          {props.mobileSetTime && (
            <div className={cx('date-timeset')}>
              <span>{props.mobileSetTime} | </span>시작 시간 선택
            </div>
          )}
          <div>
            {props.use12Hours && (
              <ul className={cx('time-part')} style={{ marginRight: '8px' }}>
                <li onClick={() => setPart('오전')} className={cx(part === '오전' ? 'active' : '')}>
                  오전
                </li>
                <li onClick={() => setPart('오후')} className={cx(part === '오후' ? 'active' : '')}>
                  오후
                </li>
              </ul>
            )}
            <ul className={cx('hour', props.use12Hours && 'hour-half')}>
              {(() => {
                const hourList = [];
                const timeStep = props.use12Hours ? 12 : 24;

                for (let i = 0; i < timeStep; i++) {
                  hourList.push(
                    <li
                      key={i}
                      onClick={() => setHour(i)}
                      className={cx(hour === i ? 'active' : '')}
                    >
                      {i.toString().padStart(2, '0')}
                      {props.use12Hours && <>시</>}
                    </li>,
                  );
                }

                return hourList;
              })()}
            </ul>
            <ul className={cx('minute', props.use12Hours && 'minute-half')}>
              {(() => {
                const minuteList = [];
                const minuteStep = props.use12Hours ? 30 : 10;
                for (let i = 0; i < 60; i += minuteStep) {
                  minuteList.push(
                    <li
                      key={i}
                      onClick={() => {
                        setMinute(i);
                      }}
                      className={cx(minute === i ? 'active' : '')}
                    >
                      {i.toString().padStart(2, '0')}
                      {props.use12Hours && <>분</>}
                    </li>,
                  );
                }

                return minuteList;
              })()}
            </ul>
          </div>
          {props.inputexist && (
            <div className={cx('button-wrapper')}>
              <button
                onClick={() => (minute !== null && minute + hour > 0 ? setInputOpen(false) : null)}
                style={{
                  backgroundColor: (minute !== null && minute + hour > 0) || '#dddddd',
                }}
              >
                선택완료
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
function TimeRangePicker(props) {
  const [startTime, setStartTime] = React.useState(null);
  const [endTime, setEndTime] = React.useState(null);
  const [openInput, setOpenInput] = React.useState(!props.inputExist);
  const [endInput, setEndInput] = React.useState(false);
  const [timeHover, setTimeHover] = React.useState(null);
  React.useEffect(() => {
    // props.changeHandler(dateTime)
  }, [startTime]);

  const startActiveHandler = (formatTime) => {
    setStartTime(formatTime);
    setOpenInput(false);
    setEndInput(true);
  };
  const endActiveHandler = (timeDisable, formatTime) => {
    if (!timeDisable) {
      if (moment(formatTime, 'HH:mm') <= moment('17:00', 'HH:mm')) {
        setEndTime(null);
        setStartTime(formatTime);
      }
    } else if (timeDisable) {
      setEndTime(formatTime);
    }
    if (timeDisable && startTime === null) {
      setEndInput(false);
      setOpenInput(true);
    }
  };

  return (
    <>
      <div
        className={cx(
          'time-picker-container',
          'time-range-picker-container',
          props.borderLeft ? 'border-left' : '',
        )}
      >
        {props.inputExist && (
          <>
            <input
              className={cx(
                'time-input',
                openInput ? 'open' : 'close',
                startTime === null ? 'placeholder' : '',
              )}
              value={
                startTime === null
                  ? '체크인 시간을 선택해 주세요.'
                  : moment(startTime, 'HH:mm').format('체크인 a h시 mm분')
              }
              onClick={() => {
                setOpenInput(true);
                setEndInput(false);
              }}
              readOnly
            />
            <span>~</span>
            <input
              className={cx(
                'time-input',
                endInput ? 'open' : 'close',
                endTime === null ? 'placeholder' : '',
              )}
              value={
                endTime === null
                  ? '체크아웃 시간을 선택해 주세요.'
                  : moment(endTime, 'HH:mm').format('체크아웃 a h시 mm분')
              }
              onClick={() => {
                setEndInput(true);
                setOpenInput(false);
              }}
              readOnly
            />
          </>
        )}
        <div
          className={cx(
            'time-picker-container',
            openInput || endInput ? '' : 'time-picker-container-close',
          )}
        >
          <ul className={cx(openInput ? '' : 'time-picker-container-close')}>
            {(() => {
              const timeList = [];
              let i = moment('9:00', 'HH:mm');
              while (i <= moment('22:00', 'HH:mm')) {
                let formatTime = moment(i).format('HH:mm');
                let timeStandard =
                  endTime === null
                    ? moment('22:00', 'HH:mm').subtract(
                        props.minCheckTime ? props.minCheckTime : 5,
                        'hours',
                      )
                    : moment(endTime, 'HH:mm').subtract(
                        props.minCheckTime ? props.minCheckTime : 5,
                        'hours',
                      );
                let timedisable = i <= timeStandard;
                let timeDistance =
                  moment(startTime, 'HH:mm') < moment(formatTime, 'HH:mm') &&
                  moment(endTime, 'HH:mm') > moment(formatTime, 'HH:mm');
                let timeHoverDistance =
                  moment(endTime, 'HH:mm') > moment(formatTime, 'HH:mm') &&
                  moment(timeHover, 'HH:mm') < moment(formatTime, 'HH:mm');

                timeList.push(
                  <li
                    onClick={() => (timedisable ? startActiveHandler(formatTime) : null)}
                    onMouseEnter={() => {
                      setTimeHover(formatTime);
                    }}
                    style={{ background: timeHoverDistance ? '#f6f6f6' : '' }}
                    className={cx(
                      endTime === formatTime || startTime === formatTime ? 'active' : '',
                      timedisable ? '' : 'disable',
                      timeDistance ? 'between-time' : '',
                    )}
                  >
                    {formatTime}
                  </li>,
                );
                i.add(30, 'minutes');
              }

              return timeList;
            })()}
          </ul>
          <ul className={cx(endInput ? '' : 'time-picker-container-close')}>
            {(() => {
              const timeList = [];
              let i = moment('9:00', 'HH:mm');
              while (i <= moment('22:00', 'HH:mm')) {
                let formatTime = moment(i).format('HH:mm');
                let timeStandard =
                  startTime === null
                    ? moment('9:00', 'HH:mm').add(
                        props.minCheckTime ? props.minCheckTime : 5,
                        'hours',
                      )
                    : moment(startTime, 'HH:mm').add(
                        props.minCheckTime ? props.minCheckTime : 5,
                        'hours',
                      );
                let timeDisable = timeStandard <= i;
                let timeDistance =
                  moment(startTime, 'HH:mm') < moment(formatTime, 'HH:mm') &&
                  moment(endTime, 'HH:mm') > moment(formatTime, 'HH:mm');
                let timeHoverDistance =
                  moment(startTime, 'HH:mm') < moment(formatTime, 'HH:mm') &&
                  moment(timeHover, 'HH:mm') > moment(formatTime, 'HH:mm');

                timeList.push(
                  <li
                    onClick={() => endActiveHandler(timeDisable, formatTime)}
                    onMouseOver={() => {
                      setTimeHover(formatTime);
                    }}
                    style={{ background: timeHoverDistance ? '#f6f6f6' : '' }}
                    className={cx(
                      endTime === formatTime || startTime === formatTime ? 'active' : '',
                      timeDisable ? '' : 'disable',
                      timeDistance ? 'between-time' : '',
                    )}
                  >
                    {formatTime}
                  </li>,
                );
                i.add(30, 'minutes');
              }

              return timeList;
            })()}
          </ul>
          <div className={cx('time-picker-info')}>
            <span>
              <span>!</span>
              {props.minCheckTime ? props.minCheckTime : 5}시간 이상으로만 운영할 수 있어요.
            </span>
            <button
              style={{
                background: startTime !== null && endTime !== null ? 'rgb(30, 30, 30)' : '#dddddd',
              }}
              onClick={() =>
                startTime !== null && endTime !== null && props.inputExist
                  ? (setOpenInput(false), setEndInput(false))
                  : null
              }
            >
              선택 완료
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
export { TimePicker, TimeRangePicker };
